<template>
  <v-container>
    <div id="grid-relator">
      <v-layout
        v-if="
          usuarioLoggedTipe == 'PROVEEDOR' ||
          usuarioLoggedTipe == 'ADMINISTRADOR'
        "
      >
        <v-flex xs3 order-md2 order-xs1>
          <v-btn color="primary" @click="newRelator()">Nuevo Relator</v-btn>
        </v-flex>
        <v-flex xs4 order-md1>
          <v-btn color="primary" @click="descargaRelator()"
            >Descarga Plantilla Relator</v-btn
          >
        </v-flex>
      </v-layout>
      <v-layout
        v-if="
          usuarioLoggedTipe == 'PROVEEDOR' ||
          usuarioLoggedTipe == 'ADMINISTRADOR'
        "
      >
        <v-flex xs3 order-md4 class="mx-3">
          <v-btn
            depressed
            outline
            icon
            fab
            dark
            color="primary"
            medium
            title="Cargar planilla"
            :disabled="desactivarUpload == true ? true : false"
            @click="processFile()"
            >cargar</v-btn
          >
        </v-flex>
        <v-flex xs4 order-md3 grid-list-xl class="mx-2">
          <v-toolbar-title class="indigo--text"
            >Carga masiva relator</v-toolbar-title
          >
          <data-adjunto
            :documentoId="id"
            :tipeView="tipeView"
            :tipeArchive="tipeArchive"
          ></data-adjunto>
        </v-flex>
      </v-layout>
      <v-layout class="d-flex pa-2">
        <div class="d-flex pa-2" xs12 sm6>
          <v-text-field
            width="300px"
            v-model="txtBusqueda"
            label="Ingresa el nombre o código para la busqueda por palabra clave"
            single-line
          ></v-text-field>
          <v-btn
            color="primary"
            @click="loadData()"
            :disabled="txtBusqueda.length < 3"
            ><v-icon dark left>search</v-icon>Buscar</v-btn
          >
          <v-btn
            color="secondary"
            @click="limpiaBuscador()"
            :disabled="txtBusqueda.length < 3"
            class="shrink"
            ><v-icon dark left>backspace</v-icon>Limpiar</v-btn
          >
        </div>
      </v-layout>

      <v-toolbar card color="white">
        <v-toolbar-title class="indigo--text"
          >Gestión de relatores</v-toolbar-title
        >
      </v-toolbar>

      <v-layout justify-center>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="listaRelatores"
            hide-actions
            :pagination.sync="miPaginacion"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td nowrap>{{ props.item.rut + "-" + props.item.dv }}</td>
              <td class="text-xs-left">
                {{
                  props.item.nombre +
                  " " +
                  props.item.apellido1 +
                  " " +
                  props.item.apellido2
                }}
              </td>
              <td class="text-xs-left">{{ props.item.capacitacion }}</td>
              <td>{{ estadoInhabilitado(props.item.rcInhabilitado) }}</td>
              <td class="text-xs-left">
                {{ estadoAgencia(props.item.aptoAgencia) }}
              </td>
              <td class="text-xs-left">{{ estadoFinal(props.item.estado) }}</td>
              <td>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="green darken-4"
                  small
                  title="Ver Relator"
                  @click="viewRelator(props.item.id)"
                >
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <v-btn
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Editar Relator"
                  @click="editRelator(props.item.id)"
                >
                  <v-icon>open_in_new</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    (usuarioLoggedTipe == 'AGENCIA' ||
                      usuarioLoggedTipe == 'ADMINISTRADOR') &&
                    props.item.aptoAgencia == 0 &&
                    (props.item.estado != 1 || props.item.estado != 2)
                  "
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Apto"
                  @click="aprobarAptoAgencia(props.item.id, 1)"
                >
                  <v-icon>done</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    (usuarioLoggedTipe == 'AGENCIA' ||
                      usuarioLoggedTipe == 'ADMINISTRADOR') &&
                    props.item.aptoAgencia == 0 &&
                    (props.item.estado != 1 || props.item.estado != 2)
                  "
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="error"
                  small
                  title="No Apto"
                  @click="aprobarAptoAgencia(props.item.id, 2)"
                >
                  <v-icon>clear</v-icon>
                </v-btn>

                <v-btn
                  v-if="
                    (usuarioLoggedTipe == 'AGENCIA' ||
                      usuarioLoggedTipe == 'ADMINISTRADOR') &&
                    props.item.aptoAgencia == 1
                  "
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Aprobar Capacitaciones"
                  @click="aprobarCapacitaciones(props.item.id)"
                >
                  <v-icon>school</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    props.item.filenameCv != null && props.item.filenameCv != ''
                  "
                  depressed
                  outline
                  icon
                  fab
                  dark
                  color="primary"
                  small
                  title="Descargar CV"
                  @click="downloadCv(props.item.id, props.item.filenameCv)"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >&nbsp;Ver relator
            <v-flex v-if="usuarioLoggedTipe == 'PROVEEDOR'">
              <v-btn
                class="btn-sigas"
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
              >
                <v-icon>open_in_new</v-icon> </v-btn
              >&nbsp;Editar relator
              <v-btn
                class="btn-sigas"
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
              >
                <v-icon>cloud_download</v-icon> </v-btn
              >&nbsp;Descargar C.V
            </v-flex>
            <v-flex v-if="usuarioLoggedTipe == 'AGENCIA'">
              <v-btn
                class="btn-sigas"
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
              >
                <v-icon>done</v-icon> </v-btn
              >&nbsp;Apto
              <v-btn v-if="getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
                class="btn-sigas"
                depressed
                outline
                icon
                fab
                dark
                color="error"
                small
              >
                <v-icon>clear</v-icon> </v-btn
              >&nbsp;No Apto
              <v-btn
                class="btn-sigas"
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
              >
                <v-icon>school</v-icon> </v-btn
              >&nbsp;Aprobar Capacitaciones
              <v-btn
                class="btn-sigas"
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
              >
                <v-icon>cloud_download</v-icon> </v-btn
              >&nbsp;Descargar C.V
            </v-flex>
          </v-card-actions>
          <v-dialog v-model="dialogLoading" persistent max-width="390">
            <loading-descarga></loading-descarga>
          </v-dialog>
        </v-flex>
      </v-layout>
      <!-- PAGINACION -->
      <v-flex xs12 sm6>
        <v-text-field
          value=""
          label="Total de Registros"
          v-model="listaRelatores.length"
          disabled
        ></v-text-field>
      </v-flex>
      <div class="pt-2">
        <v-pagination
          v-model="miPaginacion.page"
          :length="numPaginas"
          :total-visible="9"
          circle
        ></v-pagination>
      </div>
      <v-flex>
        <v-btn color="primary" @click="descargaMasiva()">Descarga masiva</v-btn>
      </v-flex>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </div>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline" style="font-weight: bold"
          >Se encontraron los siguientes errores:</v-card-title
        >

        <v-card-title
          v-if="arrRutDuplicados.length > 0"
          style="font-weight: bold"
          >Rut Duplicados con el mismo tipo de capacitación
          asignada:</v-card-title
        >
        <ul v-if="arrRutDuplicados.length > 0">
          <li v-for="(rutDuplicados, index) in arrRutDuplicados" :key="index">
            {{ rutDuplicados }}
          </li>
        </ul>
        <v-card-title
          v-if="arrRutIncorrectos.length > 0"
          style="font-weight: bold"
          >Rut Incorrectos:</v-card-title
        >
        <ul v-if="arrRutIncorrectos.length > 0">
          <li v-for="(rutIncorrectos, index) in arrRutIncorrectos" :key="index">
            {{ rutIncorrectos }}
          </li>
        </ul>
        <v-card-title v-if="arrDvErrors.length > 0" style="font-weight: bold"
          >Dígito Verificador (DV) incorrectos (permitidos: 1..9 y
          K):</v-card-title
        >
        <ul v-if="arrDvErrors.length > 0">
          <li v-for="(dvErrors, index) in arrDvErrors" :key="index">
            {{ dvErrors }}
          </li>
        </ul>
        <v-card-title
          v-if="arrCapacitacionesErrors.length > 0"
          style="font-weight: bold"
          >Códigos de tipos de capacitación erróneos:</v-card-title
        >
        <ul v-if="arrCapacitacionesErrors.length > 0">
          <li
            v-for="(capacitacion, index) in arrCapacitacionesErrors"
            :key="index"
          >
            {{ capacitacion }}
          </li>
        </ul>
        <v-card-title
          v-if="arrProfesionErrors.length > 0"
          style="font-weight: bold"
          >Códigos de Profesiones erróneos:</v-card-title
        >
        <ul v-if="arrProfesionErrors.length > 0">
          <li v-for="(profesiones, index) in arrProfesionErrors" :key="index">
            {{ profesiones }}
          </li>
        </ul>
        <v-card-title v-if="arrBadUrl.length > 0" style="font-weight: bold"
          >URL del CV Relator mal escritas o no corresponden a lo
          esperado:</v-card-title
        >
        <ul v-if="arrBadUrl.length > 0">
          <li v-for="(badUrl, index) in arrBadUrl" :key="index">
            {{ badUrl }}
          </li>
        </ul>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="indigo darken-1" flat="flat" @click="dialog = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from "axios";
import DataAdjunto from "@/components/AdjuntoData.vue";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-relator",

  components: {
    DataAdjunto,
    LoadingDescarga,
    Loading,
    AlertEmpty,
  },
  props: {
    tipeView: String,
  },

  data() {
    return {
      txtBusqueda: "",
      listaRelatores: [],
      miPaginacion: {
        rowsPerPage: 20,
      },
      arrRutDuplicados: [],
      arrRutIncorrectos: [],
      arrCapacitacionesErrors: [],
      arrDvErrors: [],
      arrProfesionErrors: [],
      arrBadUrl: [],
      dialog: false,
      dialogLoading: false,
      loading: false,
      desactivarUpload: false,
      usuarioLoggedTipe: "",
      alerta: false,
      id: "",
      idContrato: "",
      headers: [
        { text: "Rut Relator", align: "left", sortable: false, value: "rut" },
        { text: "Nombre", sortable: false, value: "nombre" },
        {
          text: "Tipo Capacitacion",
          sortable: false,
          value: "tipoCapacitacion",
        },
        { text: "RC-Inhabilidad", sortable: false, value: "rcInhabilitado" },
        { text: "Apto Agencia", sortable: false, value: "aptoAgencia" },
        { text: "Estado Capacitación", sortable: false, value: "estado" },
        {
          text: "Accion",
          sortable: false,
          value: "",
          tabSelected: "",
        },
      ],
      bloqueo: Boolean,
      proceso: "",
      tipeArchive: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.tabSelected = this.$store.getters.subTabSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.tipeArchive = ".xlsx";
    this.loadData();
  },

  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    estadoAgencia(id) {
      if (id == 0) {
        return "No procesado aún";
      } else if (id == 1) {
        return "Apto";
      } else if (id == 2) {
        return "No Apto";
      }
    },
    estadoInhabilitado(id) {
      if (id == 0) {
        return "No procesado aún";
      } else if (id == 1) {
        return "Habilitado";
      } else if (id == 2) {
        return "Inhabilitado";
      }
    },
    estadoFinal(id) {
      if (id == 0) {
        return "No evaluado aún al 100%";
      } else if (id == 1) {
        return "Aprobado";
      } else if (id == 2) {
        return "Reprobado";
      }
    },
    async loadRelatoresFilter() {
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        txtBusqueda: this.txtBusqueda,
      };
      return await axios
        .post("/relator/filter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log("error filtro relatores:" + error.response.data);
          }
          return [];
        });
    },
    limpiaBuscador() {
      this.txtBusqueda = "";
      this.loadData();
    },
    async loadData() {
      this.loading = true;
      this.listaRelatores = [];
      this.miPaginacion.totalItems = 0;
      this.listaRelatores = await this.loadRelatoresFilter();
      this.miPaginacion.totalItems = this.listaRelatores.length;
      if (this.listaRelatores.length > 0) {
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },
    descargaMasiva() {
      this.dialogLoading = true;
      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        rcInhabilitado: this.rc_inhabilitadoValue,
        apto: this.aptoValue,
        tipoCapacitacion: this.tipo_capValue,
      };
      axios
        .post("/relator/downloadExcel", this.body, { responseType: "blob" })
        .then(function (response) {
          console.log("descargaMasiva ok:");
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_RELATORES.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log("falla descargaMasiva:" + error);
        });
    },
    descargaRelator() {
      this.dialogLoading = true;
      axios
        .get("/relator/download/" + this.idContrato, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "PLANILLA_RELATORES.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reload() {
      setTimeout(() => {
        this.$parent.reloadDocumento();
      }, 1000);
    },
    processFile() {
      this.desactivarUpload = true;
      this.loading = true;
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        documento: base64EncodedStr,
        idContrato: idContrato,
      };
      axios
        .post("/relator/readFile", this.body)
        .then((response) => {
          this.resp = response.data;
          // window.getApp.$emit("APP_SAVE");
          if (
            this.resp.capacitacionErrors.length > 0 ||
            this.resp.dvErrors.length > 0 ||
            this.resp.capacitacionErrors.length > 0 ||
            this.resp.rutDuplicados.length > 0 ||
            this.resp.rutIncorrectos.length > 0
          ) {
            this.arrRutDuplicados = this.resp.rutDuplicados;
            this.arrRutIncorrectos = this.resp.rutIncorrectos;
            this.arrProfesionErrors = this.resp.profesionErrors;
            this.arrDvErrors = this.resp.dvErrors;
            this.arrCapacitacionesErrors = this.resp.capacitacionErrors;
            this.arrBadUrl = this.resp.urlFileBad;
            this.dialog = true;
            this.loadData();
            this.loading = false;
            this.desactivarUpload = false;
          } else {
            this.cargaMasiva();
          }
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loadData();
            this.loading = false;
            this.desactivarUpload = false;
          }
        });
    },
    cargaMasiva() {
      this.desactivarUpload = true;
      this.loading = true;
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        documento: base64EncodedStr,
        idContrato: idContrato,
      };
      axios
        .post("/relator/cargaMasiva", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.loadData();
          this.loading = false;
          this.desactivarUpload = false;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loadData();
            this.loading = false;
            this.desactivarUpload = false;
          }
        });
    },

    newRelator() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "RelatorRegistra",
          params: { tipeView: "crear" },
        });
      }, 1000);
    },
    editRelator(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "RelatorRegistra",
          params: { id: id, tipeView: "modifica" },
        });
      }, 1000);
    },
    viewRelator(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "RelatorRegistra",
          params: { id: id, tipeView: "consulta" },
        });
      }, 1000);
    },
    aprobarCapacitaciones(id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "RelatorRegistra",
          params: { id: id, tipeView: "aprobacion" },
        });
      }, 1000);
    },
    downloadCv(idRelator, filenameCv) {
      this.dialogLoading = true;

      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        fileName: filenameCv,
        idContrato: idContrato,
        id: idRelator,
      };
      axios
        .post("relator/downloadCV", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filenameCv);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    aprobarAptoAgencia(id, aptoAgencia) {
      this.body = {
        id: id,
        idContrato: this.idContrato,
        aptoAgencia: aptoAgencia,
      };
      axios
        .put("/relator/updateAptoAgencia", this.body)
        .then((response) => {
          this.resp = response.data;
          console.log(response.data);
          window.getApp.$emit("APP_SAVE");
          this.loadData();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error);
          this.loadData();
        });
    },
    inhabilitarRelator(id, rc) {
      this.body = {
        id: id,
        idContrato: this.idContrato,
        rcInhabilitado: rc,
      };
      axios
        .put("/relator/inhabilitarRelator", this.body)
        .then((response) => {
          this.resp = response.data;
          console.log(response.data);
          window.getApp.$emit("APP_SAVE");
          this.loadData();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error);
          this.loadData();
        });
    },
  },
};
</script>